import $ from 'jquery';
import 'bootstrap';
/**
 * Enables the home page functionality.
 */
const enableHomePageFunctionality = () => {
    if ($('#home').length === 0) {
        return;
    }
    // scroll to the anchor when clicking on navigation links
    $('.nav-item').on('click', function (e) {
        e.preventDefault();
        const $anchor = ($($('.nav-link', $(this)).attr('href') || ''));
        const coords = $anchor.offset();
        if (!coords) {
            return;
        }
        $('html, body').animate({
            scrollTop: coords.top
        }, 'slow');
    });
    $('header a.btn').on('click', function (e) {
        e.preventDefault();
        const $anchor = $($(this).attr('href') || '');
        const coords = $anchor.offset();
        if (!coords) {
            return;
        }
        $('html, body').animate({
            scrollTop: coords.top
        }, 'slow');
    });
    // enable "back to top" functionality
    $('.navbar-brand').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 800);
    });
    // enable the carousel
    $('header .carousel').carousel({
        interval: 10000,
        pause: false,
        ride: 'carousel'
    });
    // enable the popovers
    $('[data-toggle="popover"]').popover({
        trigger: 'focus'
    });
};
export default enableHomePageFunctionality;
